module.exports = __webpack_public_path__ + "assets/media/day35.e509a776.mp3";